import { TextField } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../../healtheraComponents';
import { loadAnimation } from './shared';

const LoadingField = () => {
  return (
    <>
      <Box>
        <LoadingInput />
      </Box>
      <Box>
        <LoadingInput />
      </Box>
      <Box>
        <LoadingInput />
      </Box>
      <Box>
        <LoadingInput />
      </Box>
    </>
  );
};

const Box = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

const LoadingInput = styled(TextField).attrs({
  InputProps: {
    disableUnderline: true
  }
})`
  && {
    width: 100%;
    input,
    textarea {
      padding: 8px;
      background-color: ${colors.GRAY_LIGHTER};
      cursor: default;

      &:focus {
        cursor: text;
      }
    }
    animation: ${loadAnimation} 0.7s linear alternate infinite;
  }
`;

export default LoadingField;
